import React from "react";
import { useTranslation } from "../i18n";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="privacy-overlay" onClick={onClose}>
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t("privacy.title")}</h2>
        <div className="privacy-content">
          <p><strong>{t("privacy.lastUpdate")}</strong></p>

          <h3>{t("privacy.section1Title")}</h3>
          <p>{t("privacy.section1Text")}</p>

          <h3>{t("privacy.section2Title")}</h3>
          <p>{t("privacy.section2Intro")}</p>
          <ul>
            <li><strong>{t("privacy.section2Required").split(":")[0]}:</strong>{t("privacy.section2Required").split(":").slice(1).join(":")}</li>
            <li><strong>{t("privacy.section2Optional").split(":")[0]}:</strong>{t("privacy.section2Optional").split(":").slice(1).join(":")}</li>
          </ul>

          <h3>{t("privacy.section3Title")}</h3>
          <p>{t("privacy.section3Intro")}</p>
          <ul>
            <li>{t("privacy.section3Item1")}</li>
            <li>{t("privacy.section3Item2")}</li>
            <li>{t("privacy.section3Item3")}</li>
          </ul>

          <h3>{t("privacy.section4Title")}</h3>
          <p>{t("privacy.section4Text")}</p>

          <h3>{t("privacy.section5Title")}</h3>
          <p>{t("privacy.section5Text")}</p>

          <h3>{t("privacy.section6Title")}</h3>
          <p>{t("privacy.section6Intro")}</p>
          <ul>
            <li>{t("privacy.section6Item1")}</li>
            <li>{t("privacy.section6Item2")}</li>
            <li>{t("privacy.section6Item3")}</li>
            <li>{t("privacy.section6Item4")}</li>
          </ul>

          <h3>{t("privacy.section7Title")}</h3>
          <p>
            {t("privacy.section7Text", {
              instagram: "@mixordiamusic",
              email: "mixordiamusic@gmail.com",
            })}
          </p>
        </div>

        <button className="main-button" onClick={onClose}>
          {t("privacy.close")}
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
